import { render, staticRenderFns } from "./temperingView.vue?vue&type=template&id=80bbc656&scoped=true"
import script from "./temperingView.vue?vue&type=script&lang=js"
export * from "./temperingView.vue?vue&type=script&lang=js"
import style0 from "./temperingView.vue?vue&type=style&index=0&id=80bbc656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bbc656",
  null
  
)

export default component.exports